import type { Icon } from 'types';

type Props = { fill: string } & Icon;

export default function TikTokIcon({ fill, height, width }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="4 3.3 17.5 17.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill}
        d="M19.9498 10.8979V8.05785C18.6198 8.05785 17.6048 7.70285 16.9498 7.01285C16.2775 6.22538 15.9009 5.22813 15.8848 4.19285V3.98785L13.1998 3.92285C13.1998 3.92285 13.1998 4.03785 13.1998 4.19285V15.4579C13.1077 15.9611 12.8634 16.424 12.4999 16.7841C12.1364 17.1441 11.6711 17.3839 11.167 17.4712C10.6628 17.5584 10.1441 17.4889 9.68068 17.272C9.21729 17.055 8.83157 16.7012 8.57573 16.2581C8.31988 15.8151 8.20607 15.3042 8.24981 14.7944C8.29355 14.2846 8.49249 13.8005 8.82001 13.4075C9.14753 13.0144 9.58777 12.7313 10.0813 12.5963C10.5748 12.4614 11.0979 12.4811 11.5798 12.6529V9.90285C11.2988 9.85681 11.0146 9.8334 10.7298 9.83285C9.7053 9.83285 8.70383 10.1367 7.85198 10.7058C7.00014 11.275 6.33621 12.084 5.94413 13.0306C5.55205 13.9771 5.44955 15.0186 5.64934 16.0234C5.84912 17.0282 6.34257 17.9512 7.06699 18.6757C7.79141 19.4001 8.71443 19.8934 9.71923 20.0933C10.724 20.2932 11.7656 20.1906 12.7121 19.7985C13.6586 19.4065 14.4676 18.7426 15.0368 17.8907C15.606 17.0389 15.9098 16.0374 15.9098 15.0129C15.9093 14.8006 15.8959 14.5885 15.8698 14.3779V9.80285C17.0907 10.5653 18.5112 10.9466 19.9498 10.8979Z"
      />
    </svg>
  );
}
